module.exports = __webpack_public_path__ + "img/multi-vendor_orders.4ee20517.png";